import { createSlice } from "@reduxjs/toolkit";
import { Permissions } from "../types/permissions";

const initialState = {
  username: null as string | null,
  role: null as string | null,
  permissions: {} as Permissions,
  loading: false,
};

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setUsername, setRole, setPermissions, setLoading } =
  permissionsSlice.actions;
export default permissionsSlice.reducer;
